import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/nunito/latin-700.css";
import "@fontsource/nunito/latin-800.css";
import App from "./App";
import "./styles.css";
import "./exercises/learning-fonts.css";
import { RealtimeProvider } from "./realtime/RealtimeContext";
import { WhiteboardProvider } from "./whiteboard/WhiteboardContext";
import { SoloWhiteboardProvider } from "./whiteboard/SoloWhiteboardContext";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RealtimeProvider><WhiteboardProvider><SoloWhiteboardProvider><App /></SoloWhiteboardProvider></WhiteboardProvider></RealtimeProvider>
  </StrictMode>,
);
